/**
 * @Important: This file is used by the CMMS module to define the statuses for each entity.
 * If you want to add a new entity, you need to add it here.
 * If you want to add a new status for an existing entity,
 * you need to add it here and the status should be provided in
 * [Statuses]{@link /src/app/shared/ui-components/au-cmms-status-label/statuses.ts}.
 */
export const CMMS_STATUSES = {
	WORK_ORDERS: ['TODO', 'IN_PROGRESS', 'COMPLETED'],
	INCIDENTS: ['OPEN', 'IN_PROGRESS', 'WAITING', 'CLOSED'],
	REQUESTS: ['TODO', 'IN_PROGRESS', 'COMPLETED'],
};
